import React from 'react';
import './MealSuggestionFailure.css';

const MealSuggestionFailure = ({ onRetry, onEdit, onDismiss, message = null, retryable = true }) => (
  <div className="meal-suggestion-failure" role="alert">
    <div className="meal-suggestion-failure__title">Suggestion unavailable</div>
    <p>{message || 'That recipe could not be generated safely in time. Your meal was not changed.'}</p>
    <div className="meal-suggestion-failure__actions">
      {retryable ? (
        <button type="button" className="meal-suggestion-failure__retry" onClick={onRetry}>
          Try again
        </button>
      ) : (
        <button type="button" className="meal-suggestion-failure__retry" onClick={onEdit}>
          Edit request
        </button>
      )}
      <button type="button" className="meal-suggestion-failure__dismiss" onClick={onDismiss}>
        Dismiss
      </button>
    </div>
  </div>
);

export default MealSuggestionFailure;
